module.exports = __webpack_public_path__ + "img/drivenfunding-white-text-only-powered.5c9c4e40.png";